import * as turf from '@turf/turf'
const defaultUnit = 'kilometer'

// accept a aLonLatElevation and return an object
// with multiple infos about the path
export const coordinatesElevation = (coordinates, unit = defaultUnit) => {
  const points = coordinates.reduce((data, point, i, original) => {
    const coords = [point[0], point[1]]
    if (data.lc) {
      // if last coords
      const from = turf.point(data.lc)
      const to = turf.point(coords)
      data.d += turf.distance(from, to, { unit })
    }
    if (data.le) {
      // total for climbing and descents up: climb, dw: descent
      if (point[2] > data.le) data.up += point[2] - data.le
      else data.dw += data.le - point[2]
    }
    if (data.min > point[2]) data.min = point[2]
    if (data.max < point[2]) data.max = point[2]
    data.lc = coords
    if (point[2]) {
      data.xy.push({ x: Math.round(data.d * 1000), y: point[2] })
      data.le = point[2]
    }
    return data
  }, {
    xy: [],
    d: 0,
    lc: null,
    le: 0,
    up: 0,
    dw: 0,
    max: 0,
    min: 100000
  })
  delete points.le
  delete points.lc
  return points
}
